import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Recommendation } from '../schemas/Recommendation';

import Format from '../helpers/Format';

const Title = styled.h2`
  margin: 0;
  margin-top: 32px;
  font-size: 16px;
  font-weight: bold;
  color: #222222;
  &:first-child {
    margin-top: 0;
  }
`;
const SubTitle = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: normal;
  color: #999999;
  &:first-child {
    margin-top: 0;
  }
`;
const Text = styled.h3`
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0;
  margin-top: 8px;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  color: #222222;
`;

export default function CCInterviewReview(props: {
  recomm: Recommendation<{
    talentTime: boolean;
    talentManner: boolean;
    talentSuitable: boolean;
  }>;
}): ReactElement {
  return (
    <>
      {props.recomm.interviewReviewDetail && (
        <>
          <SubTitle>
            {Format.dateFormatWithDay.format(
              props.recomm.interviewReviewDetail.date,
            )}{' '}
            {Format.timeFormat.format(props.recomm.interviewReviewDetail.date)}
            {' 작성함'}
          </SubTitle>
          <Title>별점 평가</Title>
          <Text>
            {Format.floatFormat.format(
              props.recomm.interviewReviewDetail.score / 2,
            )}
          </Text>
          <Title>인재가 면접 시간을 잘 맞추었나요?</Title>
          <Text>
            {props.recomm.interviewReviewDetail.review.talentTime
              ? '예'
              : '아니오'}
          </Text>
          <Title>인재의 면접 태도는 좋았나요?</Title>
          <Text>
            {props.recomm.interviewReviewDetail.review.talentManner
              ? '예'
              : '아니오'}
          </Text>
          <Title>
            인재의 경력과 능력 등이 프로필에 적힌 내용과 일치했나요?
          </Title>
          <Text>
            {props.recomm.interviewReviewDetail.review.talentSuitable
              ? '예'
              : '아니오'}
          </Text>
          <Title>그 외 다른 점은 없었나요?(선택)</Title>
          <Text>{props.recomm.interviewReviewDetail.comment ?? '-'}</Text>
        </>
      )}
    </>
  );
}
